module.exports = __webpack_public_path__ + "fonts/33CA2A_1_0.ttf";